import { render, staticRenderFns } from "./visitFacial.vue?vue&type=template&id=ba3075a2&"
import script from "./visitFacial.vue?vue&type=script&lang=js&"
export * from "./visitFacial.vue?vue&type=script&lang=js&"
import style0 from "./visitFacial.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports